// части вхождений имен userAgent для мобильных устройств
export const MOBILE_NAMES = [
    'android',
    'webos',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone',
    'opera mini',
    'iemobile',
    'mobi',
];

export const getIsMobile = (userAgent?: string | null): boolean => {
    const userAgentString = String(userAgent || '').toLowerCase();
    return MOBILE_NAMES.some(name => userAgentString.includes(name));
};
